module.exports = __webpack_public_path__ + "media/img/illustrations/icons/action-payments-d6cd5fd7b3c2e31eeb6bff6888e01033.svg";